import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useIdCardDownload = () => {
  const { toast } = useToast();

  const downloadIdCard = async (filePath: string) => {
    try {
      const { data, error } = await supabase.storage
        .from('id_cards')
        .download(filePath);

      if (error) throw error;

      const url = URL.createObjectURL(data);
      const a = document.createElement('a');
      a.href = url;
      a.download = filePath.split('/').pop() || 'id-card.pdf';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Download error:', error);
      toast({
        variant: "destructive",
        title: "Download failed",
        description: "Failed to download ID card"
      });
    }
  };

  return { downloadIdCard };
};